import React, { useState } from 'react';
import axios from 'axios';
import config from '../../config';

const ForgotModal = ({ closeModal }) => {
    const [phone, setPhone] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handlePhoneSubmit = async () => {
        try {
            const res = await axios.post(`${config.API_BASE_URL}/verify-phone`, { phone });
            if (res.data.valid) {
                setIsVerified(true);
                setMessage('');
            } else {
                setMessage('Phone number not found.');
            }
        } catch {
            setMessage('Error verifying phone.');
        }
    };

    const handleReset = async () => {
        // Basic password validation
        if (newPassword.includes(' ')) {
            setMessage('Password should not contain spaces.');
            return;
        }

        if (newPassword.length < 3) {
            setMessage('Password must be at least 3 characters long.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setMessage('Passwords do not match.');
            return;
        }
        try {
            await axios.post(`${config.API_BASE_URL}/reset-password`, {
                phone,
                newPassword,
            });
            setMessage('Password updated successfully!');
            setTimeout(() => closeModal(), 2000);
        } catch {
            setMessage('Error resetting password.');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <button className="close-btn" onClick={closeModal}>✖</button>
                <div className="top-header">
                <h2>Reset Password</h2>
                </div>

                {!isVerified ? (
                    <>
                        <input
                            type="text"
                            placeholder="Enter Phone Number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <button className="verify" onClick={handlePhoneSubmit}>Verify</button>
                    </>
                ) : (
                    <>
                        <input
                            type="password"
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button className="verify" onClick={handleReset}>Update Password</button>
                    </>
                )}

                {message && <p className="message">{message}</p>}
            </div>
        </div>
    );
};

export default ForgotModal;
